'use strict';

import type { UserCommissionScheduleBand } from '../../Entities/User/UserCommissionScheduleBand';
import { EntityCollection } from '../EntityCollection';

export class UserCommissionScheduleBandCollection extends EntityCollection<UserCommissionScheduleBand> {}
